import { ComponentPropsWithoutRef, ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

import { Text } from '@backstage/ui';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--bui-space-1)',
    minWidth: 0,
    flex: 1,
  },
});

type TextProps = ComponentPropsWithoutRef<typeof Text>;

interface ListItemTextWithPrimarySecondaryProps {
  primary?: ReactNode;
  secondary?: ReactNode;
  children?: never;
  className?: string;
  disableText?: boolean;
}

interface ListItemTextWithChildrenProps extends Omit<TextProps, 'children'> {
  primary?: never;
  secondary?: never;
  children: ReactNode;
}

export type ListItemTextProps =
  | ListItemTextWithPrimarySecondaryProps
  | ListItemTextWithChildrenProps;

export const ListItemText = (props: ListItemTextProps) => {
  const classes = useStyles();

  if ('children' in props && props.children !== undefined) {
    const { children, variant = 'body-medium', ...textProps } = props;
    return (
      <Text as="div" variant={variant} {...textProps}>
        {children}
      </Text>
    );
  }

  const { primary, secondary, className, disableText } = props;

  if (disableText) {
    return (
      <div className={classNames(classes.root, className)}>
        {primary}
        {secondary}
      </div>
    );
  }

  return (
    <div className={classNames(classes.root, className)}>
      {primary && (
        <Text variant="body-medium" weight="bold" as="div" truncate>
          {primary}
        </Text>
      )}
      {secondary && (
        <Text variant="body-x-small" as="div" color="secondary" truncate>
          {secondary}
        </Text>
      )}
    </div>
  );
};

ListItemText.displayName = 'ListItem.Text';
